import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { Link } from 'gatsby';
import clsx from 'clsx';
import { handleize } from '../../helpers/handleize';
import FancyTitle from '../fancy-title';

const TAGS = {
  permanent: 'Festanstellung',
  'full-time': 'Vollzeit',
};

export default function JobPositions({ blok }) {
  const styles = clsx('blok-job-positions');
  const { jobs, title, no_vacancy: noVacancy } = blok;

  return (
    <div {...storyblokEditable(blok)} className={styles}>
      <div className="grid relative px-4 lg:px-16">
        <div className="flex flex-col justify-start mt-[100px] lg:mt-60">
          <FancyTitle
            text={title}
            className="lg:text-center"
            tag="h2"
          />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-4">
            {jobs.map((position) => (
              <Link
                to={position.lang === 'en' ? `/en/${position.translated_slugs[0].path}` : `/${position.full_slug}`}
                target="_blank"
                rel="noreferrer"
                className="flex relative py-8 lg:py-20 px-8 lg:px-16 bg-latori-green-dark text-white"
                key={position.title}
              >
                <div className="absolute right-0 lg:right-3 top-0 lg:top-3 w-full flex justify-end gap-3">
                  {position.employmentType && (
                  <div className="bg-green-900 p-2 text-xs lg:text-base">{TAGS[position.employmentType]}</div>
                  )}
                  {position.schedule && (
                  <div className="bg-green-900 p-2 text-xs lg:text-base">{TAGS[position.schedule]}</div>
                  )}
                </div>
                <div className="w-full flex justify-start items-center">
                  {' '}
                  <h3 className="text-2xl lg:text-3xl font-semibold">{position.lang === 'en' ? position.translated_slugs[0].name ? position.translated_slugs[0].name : position.name : position.name}</h3>
                </div>
              </Link>
            ))}
            {!jobs.length && (
              <div className="flex col-span-full justify-center">
                <p className="lg:text-xl">{noVacancy}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
